import { useSwiperSlide } from "swiper/react";
import { audio_click } from "../lib/SoundManager";
import React from "react";

export default function App() {
  const swiperSlide = useSwiperSlide();
  
  if (!swiperSlide.isActive) {
    return <></>;
  }
  return (
    <>
      <img
        style={{
          position: "absolute",
          top: "76px",
          left: "121px",
        }}
        src="images/04/02/subtitle.png"
      ></img>
      <img
        onClick={() => {
          audio_click();
          window.open("https://slurm.schedmd.com/sacctmgr.html");
        }}
        style={{
          position: "absolute",
          top: "180px",
          left: "110px",
          cursor: "pointer",
        }}
        src="images/04/02/btn_1.png"
      />
       <img
        onClick={() => {
          audio_click();
          window.open("https://gridscheduler.sourceforge.net/htmlman/htmlman1/qconf.html");
        }}
        style={{
          position: "absolute",
          top: "180px",
          left: "740px",
          cursor: "pointer",
        }}
        src="images/04/02/btn_2.png"
      />
    </>
  );
}
